import { Component } from 'react';

import classNames from 'classnames';
import ReactDOM from 'react-dom';
import { FormattedMessage } from 'react-intl';

import styles from './Select.module.css';
import { LoadingSpinner } from '../../myAccount/ui/loadingSpinner';
import { SearchSVG } from '../../svgComponents/searchSVG';

export class Select extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value || ''
        };
    }

    // eslint-disable-next-line react/no-unsafe
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
            this.setState({ value: nextProps.value });
        }
    }

    onChange = (e) => {
        const value = e.target.value;
        this.setState({ value });
        this.props.onChange(value);
    };

    onClick = () => {
        this.props.onClick(this.state.value);
    };

    componentDidUpdate(prevProps) {
        if (!prevProps.isSearching) {
            // eslint-disable-next-line react/no-find-dom-node
            let input = ReactDOM.findDOMNode(this.refs.input);
            if (input.querySelector('input')) {
                input.querySelector('input').focus();
            }
        }
    }

    renderIcon() {
        const { isLoading } = this.props;
        return !isLoading ? (
            <SearchSVG />
        ) : (
            <LoadingSpinner className={styles.SelectLoadingSpinner} />
        );
    }

    renderSelect() {
        const {
            onFocus,
            onBlur,
            placeholder,
            onKeyDown,
            handleClick,
            isSearching,
            isLoading
        } = this.props;

        const selectIsLoading = isLoading ? styles.SelectLoading : null;

        const selectStyles = classNames(styles.SelectSearch, selectIsLoading);

        return !isSearching ? (
            <div className="input-group right">
                <div
                    data-testid="selected-value"
                    className="form-control has-values"
                    onFocus={onFocus}
                    onBlur={onBlur}
                    onClick={handleClick}
                    placeholder={placeholder || 'Search...'}
                >
                    <span className={styles.SelectedValue}>
                        <span className={styles.SelectedValueText}>
                            {this.state.value}
                        </span>
                    </span>
                </div>
                <span
                    className={styles.editBtn}
                    onClick={handleClick}
                    tabIndex="-1"
                    data-testid="edit-select-search-button"
                    onFocus={onFocus}
                    onBlur={onBlur}
                >
                    <FormattedMessage
                        id="_.select_with_search.edit"
                        defaultMessage="Edit"
                    />
                </span>
            </div>
        ) : (
            <div className="input-group right">
                {/* eslint-disable-next-line iwoca/input-a11y */}
                <input
                    className={styles.SelectInput}
                    value={this.state.value}
                    onKeyDown={onKeyDown}
                    onChange={this.onChange}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    autoComplete="off"
                    onClick={handleClick}
                    placeholder={placeholder || 'Search...'}
                />
                <span className={selectStyles} onClick={this.onClick}>
                    {this.renderIcon()}
                </span>
            </div>
        );
    }

    render() {
        // eslint-disable-next-line react/no-string-refs
        return <div ref="input">{this.renderSelect()}</div>;
    }
}
